<template>
<div container--fluid>
    <v-layout>
        <PlansModule></PlansModule>
    </v-layout>
</div>
</template>

<script>
import PlansModule from '@modules/plans/index.vue';

export default {
    name: 'plans',
    components: {
        PlansModule,
    },
    data(){
        return {
            //
        }
    },
    beforeCreate() {

    }
};
</script>

<style scoped>

</style>
